<script lang="ts">
    /* lang="ts" */
    import Input from "../leafElement/Input.svelte";
    import Select from "../leafElement/Select.svelte";
    import Label from "../leafElement/Label.svelte";
    import Switch from "../leafElement/Switch.svelte";
    import { onDestroy } from "svelte";
    import {
        getShortCombinatedTimeFormat,
        displayFormatSensorId,
    } from "../script/common.js";
    import { createEventDispatcher } from "svelte";
    import type {
        AvalibleSelectEnt,
        CustomerEnt,
        MesurmentFull,
        ProbeFull,
    } from "../script/types";
    import type { MesurmentStaticOut, ProbeOut } from "../script/requestTypes";
    import { CustomerStore } from "../script/probeStore";
    import ProbeLoader from "./ProbeLoader.svelte";
    import InputSelect from "../leafElement/InputSelect.svelte";
    /* import type { BatchData } from "../script/types"; */

    interface ProbeDes {
        data: MesurmentFull;
        displayedId: string;
        listId: string;
    }

    const dispatch = createEventDispatcher();

    let baseInfoSetate = true;

    let customerList: CustomerEnt[] = [];
    const customerSubscription = CustomerStore.subscribe((cusList) => {
        if (cusList) {
            customerList = cusList;
        } else {
            customerList = [];
        }
    });
    /* getAllCustomers().then((customerList) => {
        customerList = customerList;
    }); */
    let avalibleCustomerList;
    $: avalibleCustomerList = customerList.map((cus) => ({
        name: cus.name,
        value: cus,
    }));
    let owner_selected: CustomerEnt = null;
    let contractor_selected: CustomerEnt = null;

    let owner_subAvalible: AvalibleSelectEnt<CustomerEnt>[] = [];
    $: owner_subAvalible = hasCustomerSubelements(owner_selected)
        ? owner_selected.subElement.map((val) => {
              return {
                  name: val.ent.name,
                  value: val.ent,
              };
          })
        : [];
    let contractor_subAvalible: AvalibleSelectEnt<CustomerEnt>[] = [];
    $: contractor_subAvalible = hasCustomerSubelements(contractor_selected)
        ? contractor_selected.subElement.map((val) => {
              return {
                  name: val.ent.name,
                  value: val.ent,
              };
          })
        : [];
    let owner_subSelected: CustomerEnt = null;
    let contractor_subSelected: CustomerEnt = null;

    let allCustomerEntSelected = false;
    $: allCustomerEntSelected = Boolean(
        owner_selected &&
            (owner_subAvalible.length === 0 || owner_subSelected) &&
            contractor_selected &&
            (contractor_subAvalible.length === 0 || contractor_subSelected)
    );
    function getOwnerEnt(): CustomerEnt {
        return owner_subSelected
            ? owner_subSelected
            : owner_selected
            ? owner_selected
            : null;
    }
    function getCustomerEnt(): CustomerEnt {
        return contractor_subSelected
            ? contractor_subSelected
            : contractor_selected
            ? contractor_selected
            : null;
    }

    function hasCustomerSubelements(cus: CustomerEnt): boolean {
        return Boolean(cus && cus.subElement && cus.subElement.length !== 0);
    }

    let newSesionTemplateValid = false;
    let newSesionTemplate_sessionID = "";
    let newSesionTemplate_sessionID_placeholder = "";
    let newSesionTemplate_mesurmentCount = 3;
    let mesurmentCountFastSwitch = 0;
    $: newSesionTemplate_mesurmentCount =
        mesurmentCountFastSwitch === 0 ? 3 : 6;
    let newSesionTemplate_mesurmentVal = Array(newSesionTemplate_mesurmentCount)
        .fill(0)
        .map((_) => {
            return { temp: 0, hum: "" };
        });

    let sensorList: ProbeDes[] = [];

    $: {
        while (
            newSesionTemplate_mesurmentVal.length !==
            newSesionTemplate_mesurmentCount
        ) {
            if (
                newSesionTemplate_mesurmentVal.length >
                newSesionTemplate_mesurmentCount
            ) {
                newSesionTemplate_mesurmentVal.pop();
            } else {
                newSesionTemplate_mesurmentVal.push({
                    temp: 0,
                    hum: "",
                });
            }
        }
        newSesionTemplate_mesurmentVal = [...newSesionTemplate_mesurmentVal]; // reload
    }
    $: {
        newSesionTemplateValid = !allCustomerEntSelected;
    }
    $: {
        if (owner_selected) {
            newSesionTemplate_sessionID_placeholder = `${
                owner_selected.name
            } - ${getShortCombinatedTimeFormat(new Date())}`;
        } else {
            newSesionTemplate_sessionID_placeholder = '';
        }
    }

    function finishOfBasicInfo() {
        baseInfoSetate = false;
    }

    function addProbe(data) {
        const newProbeInfo: {
            data: MesurmentFull;
            // listId: string;
        } = data.detail;
        sensorList.push({
            data: newProbeInfo.data,
            displayedId: displayFormatSensorId(
                newProbeInfo.data.static.probe.id
            ),
            listId: newProbeInfo.data.static.id,
        });
        sensorList = [...sensorList];
    }

    function exitSesion() {
        dispatch("submit", {
            text: null,
        });
    }
    function genMesurment(probeId: string): MesurmentStaticOut {
        const now = new Date();
        const mes: MesurmentStaticOut = {
            orderNote: newSesionTemplate_sessionID
                ? newSesionTemplate_sessionID
                : newSesionTemplate_sessionID_placeholder,
            // id: probe.listId,
            //  getOwnerEnt(); getCustomerEnt()
            owner_uid: owner_selected.dbUid, // dbUid
            ownerEmployee_uid: owner_subSelected.dbUid
                ? owner_subSelected.dbUid
                : null, // dbUid
            customer_uid: contractor_selected.dbUid, // dbUid
            customerEmployee_uid: contractor_subSelected
                ? contractor_subSelected.dbUid
                : null, // dbUid
            probe: {
                id: probeId,
            },
            createdTS: now.getTime(),

            targetDataPoints: newSesionTemplate_mesurmentVal.map(
                (dataPoint, i) => {
                    return {
                        sequenceId: i,
                        value: dataPoint.temp,
                        // hum: parseFloat(dataPoint.hum),
                    };
                }
            ),
        };
        return mes;
    }
    function copyId(text) {
        navigator.clipboard.writeText(text);
    }

    function destructor() {
        customerSubscription();
    }
    onDestroy(destructor);
</script>

<div>
    <h2 class="commonMainTitle">Vytvořit &nbsp;Zakázku</h2>
    {#if baseInfoSetate}
        <div class="formDivider" style="padding-top: .5rem;">
            <p>Obecné info</p>
            <div />
        </div>
        <!-- <div class="newSesionForm"> -->
        <div class="standartButton_SMargin">
            <!-- <Select
                bind:userSelected={contractor_selected}
                nullAvalible={true}
                optionsList={avalibleCustomerList}
                name={"Objednavatel"}
            /> -->
            <InputSelect
                bind:value={contractor_selected}
                optionsList={avalibleCustomerList}
                name={"Objednavatel"}
            />
            {#if contractor_selected && contractor_subAvalible.length === 0}
                <div style="margin-bottom: 1rem;">
                    <!-- <p>Tyto informace budou zobrazeny an štítku:</p> -->
                    <Label
                        name={"e-mail:"}
                        val={contractor_selected.contact.email
                            ? contractor_selected.contact.email
                            : "--"}
                    />
                    <Label
                        name={"telefon:"}
                        val={contractor_selected.contact.phone
                            ? contractor_selected.contact.phone
                            : "--"}
                    />
                </div>
            {/if}
            {#if contractor_subAvalible.length !== 0}
                <div class="standartButton_SMargin">
                    <!-- <Select
                        bind:userSelected={contractor_subSelected}
                        nullAvalible={true}
                        optionsList={contractor_subAvalible}
                        name={"Zástupce objednavatele"}
                    /> -->
                    <InputSelect
                        bind:value={contractor_subSelected}
                        optionsList={contractor_subAvalible}
                        name={"Zástupce objednavatele"}
                    />
                    {#if contractor_subSelected}
                        <div style="margin-bottom: 1rem;">
                            <!-- <p>Tyto informace budou zobrazeny an štítku:</p> -->
                            <Label
                                name={"e-mail:"}
                                val={contractor_subSelected.contact.email
                                    ? contractor_subSelected.contact.email
                                    : "--"}
                            />
                            <Label
                                name={"telefon:"}
                                val={contractor_subSelected.contact.phone
                                    ? contractor_subSelected.contact.phone
                                    : "--"}
                            />
                        </div>
                    {/if}
                </div>
            {/if}
        </div>

        <div class="standartButton_SMargin">
            <!-- <Select
                bind:userSelected={owner_selected}
                nullAvalible={true}
                optionsList={avalibleCustomerList}
                name={"Příjemce"}
            /> -->
            <InputSelect
                bind:value={owner_selected}
                optionsList={avalibleCustomerList}
                name={"Příjemce"}
            />
            {#if owner_selected && owner_subAvalible.length === 0}
                <div style="margin-bottom: 1rem;">
                    <!-- <p>Tyto informace budou zobrazeny an štítku:</p> -->
                    <Label
                        name={"e-mail:"}
                        val={owner_selected.contact.email
                            ? owner_selected.contact.email
                            : "--"}
                    />
                    <Label
                        name={"telefon:"}
                        val={owner_selected.contact.phone
                            ? owner_selected.contact.phone
                            : "--"}
                    />
                </div>
            {/if}
            {#if owner_subAvalible.length !== 0}
                <div class="standartButton_SMargin">
                    <!-- <Select
                        bind:userSelected={owner_subSelected}
                        nullAvalible={true}
                        optionsList={owner_subAvalible}
                        name={"Zástupce příjemce"}
                    /> -->
                    <InputSelect
                        bind:value={owner_subSelected}
                        optionsList={owner_subAvalible}
                        name={"Zástupce příjemce"}
                    />
                    {#if owner_subSelected}
                        <div style="margin-bottom: 1rem;">
                            <!-- <p>Tyto informace budou zobrazeny an štítku:</p> -->
                            <Label
                                name={"e-mail:"}
                                val={owner_subSelected.contact.email
                                    ? owner_subSelected.contact.email
                                    : "--"}
                            />
                            <Label
                                name={"telefon:"}
                                val={owner_subSelected.contact.phone
                                    ? owner_subSelected.contact.phone
                                    : "--"}
                            />
                        </div>
                    {/if}
                </div>
            {/if}
        </div>
        <dir class="standartButton_SMargin" style="padding: 0; margin-top: 0;">
            <Input
                bind:val={newSesionTemplate_sessionID}
                bind:placeholder={newSesionTemplate_sessionID_placeholder}
                name={"Název"}
            />
            <span>{newSesionTemplate_sessionID_placeholder}</span>
        </dir>
        <div class="formDivider">
            <p>Požadavky na kalibraci</p>
            <div />
        </div>
        <div style="margin: 2rem 1rem;">
            <!-- <Label name={"Počet kalibrovaných bodů:"} /> -->
            <div style="margin-left: 1.5rem;">
                <!-- <Counter bind:value={newSesionTemplate_mesurmentCount} /> -->
                <Switch
                    bind:val={mesurmentCountFastSwitch}
                    iconA={"looks_3"}
                    iconB={"looks_6"}
                />
            </div>
        </div>
        <div class="newSesionTargetTemp">
            {#each newSesionTemplate_mesurmentVal as tempHumObj, i}
                <div
                    style="display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: 1rem;"
                >
                    <Input
                        bind:val={tempHumObj.temp}
                        name={"Teplota " + (i + 1)}
                        required={true}
                        inputType={"number"}
                    />
                    <!-- <Input
                        bind:val={tempHumObj.hum}
                        name={"Vlhkost " + (i + 1)}
                        placeholder={"Nespecifikovaná"}
                        inputType={"number"}
                    /> -->
                    <div />
                </div>
            {/each}
        </div>
        <div
            class="formDivider formDivider_smallMargin"
            style="margin-top: 3rem;"
        >
            <div />
        </div>
        <div style="display: flex;">
            <button
                class="standartButton standartButton_SMargin"
                on:click={exitSesion}>Zrušit</button
            >
            <button
                disabled={newSesionTemplateValid}
                class="standartButton standartButton_SMargin"
                on:click={finishOfBasicInfo}>Přejít k přidávání sond</button
            >
        </div>
    {:else}
        <div class="formDivider">
            <p>Senzory</p>
            <div />
        </div>

        <ProbeLoader mesurmentGenerator={genMesurment} on:newProbe={addProbe} />
        <div class="borderBox">
            <div class="formDivider formDivider_smallMargin">
                <p>Přidané senzory ({sensorList.length})</p>
            </div>
            <div class="sensorList">
                {#each sensorList as sensor}
                    <div class="sensorListElement">
                        <div>
                            <p>
                                ListId: <span class="sensorListElement_TextA"
                                    >{sensor.listId}</span
                                >
                            </p>
                            <p>
                                HwId: <span class="sensorListElement_TextB"
                                    >{sensor.displayedId}</span
                                >
                            </p>
                        </div>
                        <button
                            class="checkbox"
                            on:click={() => copyId(sensor.listId)}
                        >
                            <span class="material-icons">content_copy</span>
                        </button>
                    </div>
                {/each}
            </div>
        </div>
        <div
            class="formDivider formDivider_smallMargin"
            style="margin-top: 3rem;"
        >
            <div />
        </div>
        <div style="display: flex;">
            <button
                class="standartButton standartButton_SMargin"
                on:click={exitSesion}>Ukončit přidávání</button
            >
        </div>
    {/if}
</div>

<style>
    .newSesionTargetTemp {
        margin: 0.5rem 2rem;
    }
    .sensorList {
        display: flex;
        flex-wrap: wrap;
    }
    .sensorListElement {
        border: solid var(--back_D12) 1px;
        padding: 0.5rem;
        display: flex;
        align-items: center;
    }
    .sensorListElement > div {
        display: flex;
        flex-direction: column;
    }
    .sensorListElement > div > p {
        font-size: 0.9rem;
        margin: 2px 3px;
        font-size: 0.9rem;
        font-weight: 300;
        color: var(--back_D2);
    }
    .sensorListElement_TextA {
        font-weight: 500;
    }
    .sensorListElement_TextB {
        font-weight: 400;
    }
    /* duplicit with check box */
    .checkbox {
        /* position: absolute;
        top: 5px;
        right: 5px; */
        display: inline-grid;
        border-radius: 20%;
        /* border: 1px solid var(--prim); */
        background: #eee;
        z-index: 10;
        margin: 0;
        margin-left: 8px;
        padding: 3px;
    }
    .checkbox:hover {
        box-shadow: var(--prim) 0 0 2px 0px;
    }
    .checkbox > .material-icons {
        font-size: 1.1rem;
        font-weight: bold;
        color: var(--prim_L15);
    }
</style>
